module.exports = __webpack_public_path__ + "static/media/Food Ingredient.7a30c182.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cont/Food Ingredient.png
// module id = 417
// module chunks = 0